import { issuanceList, issuanceEligibleTrainees, userCertificatesBatch } from "constants/issuance";

const initialState = {
  issuanceList: {},
  eligibleTraineesData: {},
};

const issuance = (state = initialState, action) => {
  switch (action.type) {
    case issuanceList:
      return { ...state, issuanceList: action.payload };

    case issuanceEligibleTrainees:
      return { ...state, eligibleTraineesData: action.payload };

    case userCertificatesBatch:
      return { ...state, userCertificatesBatch: action.payload };

    default:
      return state;
  }
};

export default issuance;
